var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXvector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 12C1 5.92487 5.92487 1 12 1C18.0752 1 23 5.92487 23 12C23 18.0752 18.0752 23 12 23C5.92487 23 1 18.0752 1 12Z",
    stroke: "#F3223C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.3335 8.33325L15.6668 15.6666M15.6668 8.33325L8.3335 15.6666",
    stroke: "#F3223C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXvector);
export default __webpack_public_path__ + "static/media/xvector.02ac7a038a50c79a8b94ba48fbb30b91.svg";
export { ForwardRef as ReactComponent };